AuthRoute = require 'mixins/authenticated-route'

App.CategoryDishRoute = Em.Route.extend AuthRoute,
  controllerName: 'dishEdit'

  model: (params) ->
    @store.find('draft-dish', params.dish_id)

  renderTemplate: (controller, model) ->
    @render 'categories.dish-edit', controller: controller


